// Experiência total necessária para cada level, fórmula do Tibia Global.

export function expForLevel(level: number): number {
  if (!Number.isInteger(level) || level < 1) throw new Error(`level inválido: ${level}`);
  const l = level;
  return Math.round((50 / 3) * (l ** 3 - 6 * l ** 2 + 17 * l - 12));
}

/** Level correspondente a uma quantidade total de experiência. */
export function levelForExp(exp: number): number {
  let level = 1;
  while (expForLevel(level + 1) <= exp) level++;
  return level;
}

/** Multiplicador de XP do Baiak: 20x nos levels 1 a 49, caindo 1x a cada 50 levels até 1x no 950. */
export function xpStage(level: number): number {
  return Math.max(1, 20 - Math.floor(level / 50));
}

/** Porcentagem (0 a 99) já feita do level atual. */
export function levelProgress(level: number, exp: number): number {
  const cur = expForLevel(level), next = expForLevel(level + 1);
  return Math.max(0, Math.min(99, Math.floor(((exp - cur) / (next - cur)) * 100)));
}
